module.exports = __webpack_public_path__ + "img/turbo_on.b4ae6d6f.png";